// extracted by mini-css-extract-plugin
module.exports = {"SectionTitle":"SectionTitle-module--SectionTitle--3Rg0d","title":"SectionTitle-module--title--3lHbM"};